import { render, staticRenderFns } from "./ErrorBoundary.vue?vue&type=template&id=9251f59c&scoped=true"
import script from "./ErrorBoundary.vue?vue&type=script&lang=ts"
export * from "./ErrorBoundary.vue?vue&type=script&lang=ts"
import style0 from "./ErrorBoundary.vue?vue&type=style&index=0&id=9251f59c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9251f59c",
  null
  
)

export default component.exports